import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import user from './user';
import modals from './modals';
import trainings from './trainings';
import lessons from './lessons';
import contents from './contents';
import contentsTraining from './contentsTraining';
import passing from './passing';
import confirmation from './confirmation';
import infoServices from './infoServices';
import chats from './chats';
import messages from './messages';
import certificates from './certificates';
import notes from './notes';
import pictures from './pictures';
import i18n from './i18n';

export default combineReducers({
  routing: routerReducer,
  user,
  modals,
  trainings,
  lessons,
  contents,
  contentsTraining,
  passing,
  confirmation,
  infoServices,
  chats,
  messages,
  certificates,
  notes,
  pictures,
  i18n,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js